import { defineMessage } from 'services/localization';

export const messages = {
    xeroVideoTitle: defineMessage('create_and_connect_a_xe__all_the_trial_features'),
    xeroVideoDescription: defineMessage('check_out_this_video_to_nnect_it_to_approvalmax'),
    xeroVideoCreateDemo: defineMessage('create_a_demo_organisation_in_xero'),
    xeroVideoConnectDemo: defineMessage('connect_a_demo_organisation'),
    qbooksVideoTitle: defineMessage('create_and_connect_a_qu__all_the_trial_features'),
    qbooksVideoDescription: defineMessage('check_out_this_video_to_nnect_it_to_approvalmax_1'),
    qbooksVideoCreateDemo: defineMessage('create_a_quickbooks_test_organisation'),
    qbooksVideoConnectDemo: defineMessage('connect_a_test_organisation'),
};
